import { EventType } from "./EventType";
import type { IrMap } from "./IrMap";

export class EventTypeFunctions {
    public static eventTypeIcon: (eventType: EventType) => string = (eventType: EventType) => {
        switch (eventType) {
            case EventType.VideoMotionDetection:
                return "volume-up";
            case EventType.VideoFireDetection:
                return "ir-flame-detection";
            case EventType.PowerFailure:
                return "";
            case EventType.PowerReset:
                return "";
            case EventType.PhysicalObjectConnectionFailure:
                return "";
            case EventType.PhysicalObjectConnectionReset:
                return "";
            case EventType.InputModuleBinaryTriggerAlarm:
                return "";
            case EventType.SiteTestAlarmSending:
                return "";
            case EventType.SiteTestFullAlarmFlow:
                return "";
            default:
                return "";
        }
    };

    public static eventTypeBaseIcon: (eventType: EventType) => string = (eventType: EventType) => {
        switch (eventType) {
            default:
                return "volume-up";
        }
    };

    public static enhanceEventType(eventTypeString: string) {
        const typeName = eventTypeString as any as keyof typeof EventType;
        const type = EventType[typeName];
        return type;
    }

    public static enhanceAlarmEventTypes(eventTypes: IrMap<string, number>) {
        return eventTypes.map((aet) => ({
            key: this.enhanceEventType(aet.key),
            value: aet.value,
        }));
    }
}
